import { render, staticRenderFns } from "./DocumentsGeneral.vue?vue&type=template&id=4aaa9565&scoped=true"
import script from "./DocumentsGeneral.vue?vue&type=script&lang=js"
export * from "./DocumentsGeneral.vue?vue&type=script&lang=js"
import style0 from "./DocumentsGeneral.vue?vue&type=style&index=0&id=4aaa9565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa9565",
  null
  
)

export default component.exports